import { render } from "./LayoutComponent.vue?vue&type=template&id=c2bdc3b6"
import script from "./LayoutComponent.vue?vue&type=script&lang=js"
export * from "./LayoutComponent.vue?vue&type=script&lang=js"

import "./LayoutComponent.vue?vue&type=style&index=0&id=c2bdc3b6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__